import React, { useEffect, useState, useContext } from 'react'
import Button from '../formfields/Button'
import { GlobalContext } from '../GlobalContext'
import HeaderDetails from '../shared-components/HeaderDetails'
import Card from '../ui-elements/Card'
import Spinner from '../ui-elements/Spinner'
import ChecklistSummary from './ChecklistSummary'
import SummaryCheckWindow from './SummaryCheckWindow'
import { json } from 'stream/consumers'
import NoActiveCheckPeriods from './NoActiveCheckPeriods'
import NoChecklists from './NoChecklists'
import FilterChecklistCategories from './FilterChecklistCategories'
import { useNavigate, useSearchParams } from 'react-router-dom'
import ExpandCollapseIcon from '../ui-elements/ExpandCollapseIcon'
import JsonDebug from '../ui-elements/JsonDebug'
import { subscribe } from '../utils/pubsub'
import { findNextQuestionUrl } from '../utils/findNextQuestionUrl'


type Props = {
    externalUserState: null | ObjectStringKeyAnyValue,
    setExternalUserState: React.Dispatch<React.SetStateAction<any>>,
}

function ExternalUserDashboard({
    externalUserState,
    setExternalUserState,
}: Props) {

    const {
        tableData,
        currentOrganisation,
        handleLogout,
        sendMessageToWebsocket,
        setShowModal,
        checkIfThereAreQuestionsAndAnswersForChecklistPeriodId
    } = useContext(GlobalContext)

    const navigate = useNavigate()

    const thisCheckPeriodId = externalUserState && externalUserState.checklistPeriodId ? externalUserState.checklistPeriodId : null
    const thisChecklistId = externalUserState && externalUserState.checklistId ? externalUserState.checklistId : null
    const thisCheckPeriod = thisCheckPeriodId && tableData && tableData.ChecklistPeriods ? tableData.ChecklistPeriods[thisCheckPeriodId] : null
    const thisChecklist = thisChecklistId && tableData && tableData.Checklists ? tableData.Checklists[thisChecklistId] : null
    const isCheckPeriodComplete = thisCheckPeriod && thisCheckPeriod.InProgress === 'False' ? true : false
    const checklistName = thisChecklist ? thisChecklist.ChecklistName : ''



    useEffect(() => {
        thisCheckPeriodId && checkIfThereAreQuestionsAndAnswersForChecklistPeriodId(thisCheckPeriodId)
    }, [thisCheckPeriodId])


    useEffect(() => {
        console.log(externalUserState)
        if (externalUserState && externalUserState.checklistPeriodId) {
            if (
                tableData
                && tableData.ChecklistPeriods
                && tableData.ChecklistPeriods[externalUserState.checklistPeriodId]) {
                const thisCheckPeriod = tableData.ChecklistPeriods[externalUserState.checklistPeriodId]
                if (thisCheckPeriod.InProgress === 'True') {
                    console.log('In progress')
                } else {
                    console.log('Completed')
                }
            } else {
                console.log('Check period not found')
            }

        } else if (externalUserState && externalUserState.checklistId) {
            console.log('Ready')
            // startAdhocChecklistForExternalUser(externalUserState!.checklistId)
        } else {
            console.log('Error: No checklist or check period specified')
        }
    }, [externalUserState])


    return <div className={`w-full flex-1 h-full flex flex-col items-center gap-2`}>

        <HeaderDetails
            titleText={'Welcome to ChecQR'}
        />


        <div className={`max-w-3xl w-full px-5 py-5 flex flex-col gap-4`}>



            {thisCheckPeriodId && !isCheckPeriodComplete && <ChecklistSummary
                checklistId={thisChecklistId}
                thisChecklist={thisChecklist}
                checkPeriodId={thisCheckPeriodId}
            />}



            {/* <JsonDebug jsonobject={externalUserState} /> */}
            {/* {status} */}

            {isCheckPeriodComplete && <div className={`animate-fadein w-full mt-2`}>
                <Card fullwidth={true}>
                    <div className={` w-full flex flex-col gap-1 items-center justify-center`}>
                        <p className={`text-4xl`}>🏆</p>
                        <h4 className={`font-righteous text-brandblue text-2xl mb-4`}>Checklist complete</h4>

                        <Button
                            text={`Log out`}
                            onClick={handleLogout}
                            size='big'
                        />
                    </div>
                </Card>
            </div>

            }
        </div>
    </div>
}
export default ExternalUserDashboard